// tabs module
//returns angular $scope for dlTabController
var dataURL = '';

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)','i'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


var ngScope = function() {
    return angular.element(document.querySelector('.dealer-locator')).scope();
};

var tabApp = angular.module('dealerLocatorApp', []);
tabApp.controller('dlTabController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

    $scope.tab = 1;

    // for stroing data-model of 3 tabs
    $scope.tZip = {
        isError: false,
        error: 'The zip code entered was invalid. Please try again.'
    };
    $scope.tCS = {
        isError: false,
        error: 'The city or state entered was invalid. Please try again'
    };
    $scope.tName = {
        isError: false,
        error: 'The name entered was invalid. Please try again'
    };

    //data-model that can be shared between all controllers
    $scope.global = {
        loadedDealers: [],
        filteredDealers: [],
        allDealers: [],
        allCounts: []
    };

    //Show/hide tabs
    $scope.setTab = function(newTab) {

        if ($('.spinner').is(':visible'))
        {
            return;
        }

        $scope.tab = newTab;

        $timeout(function () {
            $('div.active:visible')
                .find('input')
                .eq(0).focus();
        })
        
        //loadCurrentTabData();
        $timeout(function() {
            $scope.global.filterDealers();

            $scope.global.hideTabError($scope.global.getTabScope());
        }, 100);

    };

    $scope.isSet = function(tabNum) {
        return $scope.tab === tabNum;
    };

    $scope.global.getTabScope = function(tab) {
        tab = tab || $scope.tab;

        return tab === 1 ? $scope.tZip :
            tab === 2 ? $scope.tCS :
            $scope.tName;
    }

    loadCurrentTabData = function() {

        $timeout(function() {

            angular
                .element('.dl-inputs .active .submit-btn').triggerHandler('click');

        });
    };

    $scope.global.prevZip = Number($scope.tZip.inputZip);
    //common function to get data for all the tabs
    $scope.global.getData = function(zip, tabScope) {


        //tracking
        //  callFloodlight('dealer-locator-results');

        if ($scope.global.prevZip != zip) {

            $scope.global.prevZip = zip;
            $scope.global.allDealers = [];

            $('.spinner').show();
            //$http.get("data/data-dl7-90401-new.json.txt", {
            var usedev = getParameterByName('usedev');

            switch (usedev) {
                case '1': 
                    dataURL = 'https://acuracertifieddev.rpa-dev.com';
                    break;
                case '2':
                    dataURL = 'https://acuracertifieddev2.rpa-dev.com';
                    break;
                default:
                    dataURL = '';
            }


            $http.get(dataURL + "/api/dealerlocator/finddealers", {
                params: {
                    zip: zipToString(zip),
                    radius: 250
                }
            }).then(function(res) {
                    if (res.data.status == 'failure') {
                        tabScope && $scope.global.showTabError(tabScope, 'The zip code entered was invalid. Please try again.');
                        $('.spinner').hide();
                        return;
                    }

                    //save dealer data in model
                    $scope.global.allDealers = null;

                if (res.data.Output.Results.Aggregates.Dealers == null) {
                        tabScope && $scope.global.showTabError(tabScope, 'No dealer found.');
                        $('.spinner').hide();
                        return;
                    }

                    if (res.data.Output.Results.Dealers != null) {
                        $scope.global.allDealers = res.data.Output.Results.Dealers.Dealer;
                    }

                    if ($scope.global.allDealers == null) {
                        tabScope && $scope.global.showTabError(tabScope, 'No dealer found.');
                        $('.spinner').hide();
                        return;
                    }

                    //extract count data in to model
                    var countData = [];
                    if (res.data.Output.Results.Aggregates.Dealers != null) {
                        countData = (res.data.Output.Results.Aggregates.Dealers).Dealer;
                    }

                    for (var i = 0; i < countData.length; i++) {
                        $scope.global.allCounts.push({
                            DealerID: countData[i]['@DealerID'],
                            Count: countData[i]['@Count']
                        });
                    }
                    //filter and display data on the page
                    $scope.global.filterDealers();

                    $('.spinner').hide();

                },
                //callback function if there is error loading json
                function errorCallback(counts) {

                    if (tabScope) {
                        $scope.global.showTabError(tabScope, 'An error occurred and we were not able to locate dealers. Please try again later.');
                    }

                    $('.spinner').hide();

                });

        } else {

            //filter and display data on the page
            $scope.global.filterDealers();
        }
        $scope.global.getDataForName();
    };

    $scope.global.getDataForName = function(zip) {


        //tracking
        //callFloodlight('dealer-locator-results');

        var tabScope = $scope.tName;

        if (!$scope.global.byNameDealers || $scope.global.byNameDealers.length == 0) {

            //$scope.global.prevName = searchText;
            //$scope.global.allDealers = [];

            $('.spinner').show();
            // $http.get("all-names.json", {
            var usedev = getParameterByName('usedev');

            switch (usedev) {
            case '1': 
                dataURL = 'https://acuracertifieddev.rpa-dev.com';
                break;
            case '2':
                dataURL = 'https://acuracertifieddev2.rpa-dev.com';
                break;
            default:
                dataURL = '';
            }
            
            $http.get(dataURL + "/api/dealerlocator/getalldealers", {
                params: {
                    zip: zipToString(zip),
                    //search: searchText
                }
            }).then(function(res) {

                    if (res.data.status == 'failure') {
                        tabScope && $scope.global.showTabError(tabScope, 'Dealers not found. Please try again.');
                        $('.spinner').hide();
                        return;
                    }

                    //$http.get("name-count.json", {
                    //    //  $http.get("/api/dealerlocator/getalldealers", {
                    //    params: {
                    //        dealerid: '12345',
                    //        //search: searchText
                    //    }
                    //}).then(function (countRes) {


                    //$scope.global.countsByDealerName = countRes.data;



                    //map dealer data and save in model
                    data = res.data.POIResponse.POIs.POI;
                    var finalData = [];
                    for (var i = 0; i < data.length; i++) {
                        var d = data[i];

                        finalData.push({
                            DealerDistance: d.Distance,
                            DealerURL: d.InternetAddress,
                            DealerName: d.POIName,
                            DealerAddress: d.Address,
                            DealerCity: d.City,
                            DealerState: d.State,
                            DealerZip: d.ZipCode,
                            DealerPhoneNo: d.Phone,
                            DealerID: d.POIId,
                            DealerLat: d.Latitude,
                            DealerLong: d.Longitude,
                            DealerAttributes: $scope.global.getDealerAttributes(d.POIId),
                            carCount: '' //$scope.global.getCarCountForDealerName(d.POIId) || 1,
                        });
                    }

                    $scope.global.byNameDealers = finalData;
                    //extract count data in to model
                    //var countData = (res.data.Output.Results.Aggregates.Dealers).Dealer;
                    //for (var i = 0; i < countData.length; i++) {
                    //    $scope.global.allCounts.push({
                    //        DealerID: countData[i]['@DealerID'],
                    //        Count: countData[i]['@Count']
                    //    });
                    //}

                    //filter and display data on the page
                    $scope.global.filterDealers();

                    $('.spinner').hide();

                    //});



                },
                //callback function if there is error loading json
                function errorCallback(counts) {

                    if (tabScope) {
                        $scope.global.showTabError(tabScope, 'An error occurred and we were not able to locate dealers. Please try again later.');
                    }

                    $('.spinner').hide();

                });

        } else {

            //filter and display data on the page
            $scope.global.filterDealers();
        }
    }

    //show error msg in a tab
    $scope.global.showTabError = function(tabScope, error) {
        tabScope.isError = true;
        tabScope.error = error;
        $scope.$evalAsync();
    }

    //hide error msg from the tab
    $scope.global.hideTabError = function(tabScope) {
        tabScope.isError = false;

        $('input, select').removeClass('dl-zip-error');
    }

    //zip overlay - submit zip 
    $scope.global.zipOverlaySubmit = function() {

        if (!validateInput('dl-no-zip-input'), !validateInput('dl-no-zip-input-mobile')) {
            return;
        }

        //tracking
        callFloodlight('dealer-locator-results');

        //load data as per zip
        $scope.tZip.getData();

        //hide overlay, show main panel
        $('#dl-zip-off').hide();
        $('#dl-zip-on').show();
        $(window).scrollTop(0);
    }

    //filters the dealers as per input, loads them into ng model etc
    $scope.global.filterDealers = function() {

        var allDealers = $scope.global.allDealers;
        //console.log('allDealers',allDealers.length, allDealers);
        if (allDealers == null) {
            tabScope = $scope.global.getTabScope();
            $scope.global.showTabError(tabScope, 'No dealer found.');
            return;
        }

        var filtered = [];
        var milesRange = 2500;

        dl.clearMapPins();

        $scope.global.loadedDealers = [];

        if (($scope.tab == 1 && $('#zipCodeInput').val() == '') || ($scope.tab == 2 && ($('#cityStateInput').val() == '' || $('#state').val() == '')) || ($scope.tab == 3 && $('#nameInput').val() == '')) {
            return;
        }

        //search by name 
        var dealerNameToSearch = '';
        if ($('.tab-name').hasClass('active')) {
            dealerNameToSearch = ($('#nameInput').val() || '').toUpperCase();
        }

        //filter dealers and add to ng model
        var regex = new RegExp("\\b" + dealerNameToSearch, "gi");
        for (var i = 0; i < allDealers.length; i++) {

            var dealer = allDealers[i];

            //if name-tab active, then filter by name
            if ($('.tab-name').hasClass('active') && (dealerNameToSearch == '' || regex.test(dealer.DealerName) == false )) {

                continue;
            }

            dealer.DealerHasBuyOnline = $scope.global.getHasBuyOnline(dealer);
            filtered.push(dealer);
        }

        // if name tab, then sort alphabetically
        if ($('.tab-name').hasClass('active')) {

            filtered.sort(function(a, b) {
                return a.DealerName.toUpperCase() > b.DealerName.toUpperCase();
            });
        }

        //load filtered data
        $scope.global.filteredDealers = filtered;
        $scope.global.loadedDealers = [];
        dl.clearMapPins();
        $scope.global.loadNextDealers();

        // moves map to position first result at center
        if (filtered[0]) {
            dl.drawMapCircleRange(filtered[0].DealerLat, filtered[0].DealerLong, 7);
        }
    }

    //loads dealers in chunks of 3. Data already filtered and loaded in models. It just display then 
    $scope.global.loadNextDealers = function() {

        var filtered = $scope.global.filteredDealers;
        var alreadyVisible = $scope.global.loadedDealers.length || 0;


        if (filtered.length == 0) {
            $scope.global.showTabError($scope.tName, 'No results found. Please try again');
            return;
        }

        //show next 3
        for (var i = 0; i < 3; i++) {

            if (filtered.length > alreadyVisible + i) {

                var dealer = filtered[alreadyVisible + i];

                //car count is saved at different place. Get it and add to dealer object
                dealer.carCount = $scope.tab == 3 ? dealer.carCount : ($scope.global.getCarCount(dealer.DealerID) || 1);

                // load to model for display and show pins
                $scope.global.loadedDealers.push(dealer);
                dl.addPinToMap(dealer.DealerLat, dealer.DealerLong, alreadyVisible + i + 1, dealer.DealerName, 250, dealer.carCount, dealer.DealerID);
            }
        }

         if (!$scope.$$phase) {
            $scope.$apply();
        }

    }

    //gets attributes for a dealer
    $scope.global.getDealerAttributes = function(DealerID) {
        var dealers = $scope.global.allDealers;

        for (var i = 0; i < dealers.length; i++) {
            if (dealers[i]['DealerID'] == DealerID)
                return dealers[i]['DealerAttributes']
        }

        return { DealerAttribute: [] };
    }


    //gets car count for a dealer
    $scope.global.getCarCount = function(DealerID) {

        var counts = $scope.global.allCounts;

        for (var i = 0; i < counts.length; i++) {
            if (counts[i]['DealerID'] == DealerID)
                return counts[i]['Count']
        }
        return 0;
    }

    //get car count for name tab
    $scope.global.getCarCountForDealerName = function(DealerID) {


        var counts = $scope.global.countsByDealerName;
        
        if (!counts) return;
        counts = counts.Output.Results.Models.Model;

        var res = 0;
        for (var i = 0; i < counts.length; i++) {
            if (counts[i]['@DealerId'] == DealerID)
                res = counts[i].Dealer['@Count'];
        }
        return res;

    }

    $scope.global.displayCarCountForDealerNames = function() {

        //don't do anything, if current tab is not 'Name'
        if ($scope.tab != 3) {
            return;
        }

        var $dealers = $('.dl-results').eq(0).find('.dl-result');

        //   console.log('$dealers.length', $dealers.length)

        for (var i = 0; i < $dealers.length; i++) {

            $scope.global.displayCarCountForDealer($dealers.eq(i));

        }

    }

    $scope.global.displayCarCountForDealer = function($resultDiv) {

        if ($resultDiv.find('.carCount').text() == '') {
            var dealerID = $resultDiv.attr('data-dealerid');
            var carCount = '  ';

            // $http.get("name-count.json", {
            var usedev = getParameterByName('usedev');

            switch (usedev) {
            case '1': 
                dataURL = 'https://acuracertifieddev.rpa-dev.com';
                break;
            case '2':
                dataURL = 'https://acuracertifieddev2.rpa-dev.com';
                break;
            default:
                dataURL = '';
            }

            $http.get(dataURL + "/api/dealers/getdealerinventory", {
                params: {
                    dealerid: dealerID,
                    //search: searchText
                }
            }).then(function (countRes) {
                if (countRes) {
                    // used to gather count of ModelVINsOnSite
                    var carCountArray = [];
                    var sumCarCountArray = 0;

                    var countData = countRes.data;
                    if (countData.Output.Results.Models != null) {
                        countData = countData.Output.Results.Models.Model;
                        // console.log('countdata ', countData.length);
 


                        //loop all ModelVINsOnSite and add the count to carCountArray
                        for (var i = 0; i < countData.length; i++) {
                            carCount = parseInt(countData[i].ModelVINsOnSite['@Count']);
                            // console.log(dealerID + ' ---- ' + carCount);
                            //push the count to carCountArray
                            carCountArray.push(carCount)
                        }

                        // carCount = countData[0].ModelVINsOnSite['@Count']


                        // sum up the count inside the carCountArray
                        for (var i = 0; i < carCountArray.length; i++) {
                            sumCarCountArray += carCountArray[i]
                        }
                        // console.log('carCountArray ', carCountArray);
                        // console.log('sumCarCountArray ', sumCarCountArray);
                    }

                    //inject the sum to html
                    //$resultDiv.find('.carCount').text(sumCarCountArray);
                    $('.carCount[data-dealerid="' + dealerID + '"]').text(sumCarCountArray);
                    // console.log($resultDiv, sumCarCountArray);
                }
            });
            $resultDiv.find('.carCount').text(carCount);
        }
    }

    $scope.global.getHasBuyOnline = function(dealer){
        let hasCode = false;

        if (dealer.DealerAttributes.DealerAttribute === undefined) return hasCode;

        let totalAtr = dealer.DealerAttributes.DealerAttribute;

        if (totalAtr.length <= 0) return hasCode;

        for (let i = 0; i < totalAtr.length; i++) {
            const element = totalAtr[i];
            
            if (element.Code == "CO") {
                hasCode = true;
                break;
            }
        }

        return hasCode;
    }

    //validate zip based on length
    $scope.global.validateZip = function(zip) {
        return zip && zip.length == 5;
    }
}]);